module.exports = __webpack_public_path__ + "img/lr.03762e2d.svg";